import { IPagoInfoFacturarConceptoComplemento } from "../../../../data/entidad/Factura";
import { _DICC_ALUMNO } from "../../../../data/modulo/Alumno";
import { _DICC_ESCOLARIDAD } from "../../../../data/modulo/Escolaridad";
import _L from "../../../../util/Labels";
import { Button, CBGColor } from "../../../controlD3/Button";
import { FormGenerator } from "../../../controlD3/Formulario";
import { Modal } from "../../../controlD3/Modal";
import { _ModalForm, IModalFormController } from "../../../controlD3/ModalThings/ModalForm";
import { NotificacionV2 } from "../../../controlD3/NotificacionV2";
import { HTMLTooltipComponent } from "../../../controlWC/TooltipComponent";
import { UIUtilGeneral } from "../../../util/Util";

export namespace UIUtilViewAlumnoEdoCtaFacturacionViewCFDIInfoComplemento {

    export interface CFDIItemConceptoComplemento {
        _View: HTMLElement
        _GetDataFinal: () => IComplementoIEDU | null
    }

    type IComplementoIEDU = IPagoInfoFacturarConceptoComplemento

    export function _CrearComplementoIEDUFComponent(idAlumno: number, initDataForm: Partial<IComplementoIEDU>): CFDIItemConceptoComplemento {
        initDataForm = initDataForm ? { ...initDataForm } : null

        // >> Form
        const form = CreateForm(idAlumno, initDataForm)

        // >> ModalForm
        const modalForm = CreateModalForm({
            Form: form,
            OnChange: () => {
                mainView.__RefreshUI()
            }
        })

        // > MainView
        const mainView = CreateMainView(modalForm.Modal, () => form.__FocusForm(), !!initDataForm)

        mainView.__RefreshUI()

        return {
            _View: mainView._node,
            _GetDataFinal: () => form.__GetDataForm(),
        }
    }

    // ****************************************************************************************
    // MAIN COMPONENT
    // ****************************************************************************************

    type MainView = Button & { __RefreshUI?() }
    function CreateMainView(modal: Modal, onOpenModal: (() => void), hasInitialData: boolean): MainView {
        const view: MainView = new Button(null, null, CBGColor.default)
        view._d3Selection.classed("view_complemento_iedu", true);

        // const btnReset = Button.BtnClose._GetCloseCircleButton(view._d3Selection)
        //     .style("margin-left", "var(--padding1)")

        // btnReset.node().onclick = e => {
        //     e.stopPropagation()
        //     Form.__ResetForm()
        //     view.__RefreshUI()
        // }

        const tooltip = view._d3Selection.append<HTMLTooltipComponent>("wc-tooltip").node()

        // tooltip._SetObservedElementsAdvanced({
        //     Target: btnReset.node() as any,
        //     Text: _L("general.clear"),
        // })

        view._node.onclick = () => {
            modal._Mostrar()
            if (onOpenModal) onOpenModal()
        }

        view.__RefreshUI = () => {
            if (hasInitialData) {
                view._text = _L("panelfinanzasedocuenta_factura.ins_educ")
                view._d3Selection.classed("error", false)
                // btnReset.classed("hide", false)
            } else {
                view._text = _L("panelfinanzasedocuenta_factura.sin_complemento")
                view._d3Selection.classed("error", true)
                // btnReset.classed("hide", true)
            }

            tooltip._SetObservedElementsAdvanced({
                Target: view._node.querySelector("span") || view._node,
                Text: hasInitialData ? _L("c_actions.editar") : _L("control.form.required"),
            })
        }

        return view
    }

    // ****************************************************************************************
    // MODAL FORM
    // ****************************************************************************************

    interface ModalFormConfig {
        Form: FormComplemento
        OnChange: () => void
    }
    interface ModalController extends IModalFormController<IComplementoIEDU> {
        Form: FormComplemento
    }
    function CreateModalForm({ Form, OnChange }: ModalFormConfig): ModalController {
        const modalForm = _ModalForm<IComplementoIEDU>({
            Title: _L("panelfinanzasedocuenta_factura.complemento_ins_educ"),
            Width: 515,
            GetForm: () => Form,
            AutoShow: false,
            OnClose: () => { // Cancelar
                Form.__ResetForm() // Resetear formulario a valores anteriores
            },
            OnAccept: () => {
                Form.__SetReseterData(Form._Data)
                modalForm.Modal._Ocultar(false) // No se invocará `OnClose`, OnClose funcionará como cancelar
                OnChange()
                return null
            },
        })

        return modalForm
    }

    // ****************************************************************************************
    // FORM
    // ****************************************************************************************

    type FormComplemento = FormGenerator<IComplementoIEDU> & {
        /** @deprecated */
        _Data: any
        __GetDataForm?(): IComplementoIEDU
        __ResetForm?(): void
        __SetReseterData?(dataForm: IComplementoIEDU): void
        __FocusForm?(): void
    }
    function CreateForm(idAlumno: number, initDataForm: Partial<IComplementoIEDU>): FormComplemento {
        // let hasComplementoAceptado: boolean = !!initDataForm // NOTE Por ahora un complemento es requerido, por lo que siempre debe ser TRUE
        const alumno = _DICC_ALUMNO.get(idAlumno)

        const reseterDataFormBase: Partial<IComplementoIEDU> = {
            NombreAlumno: initDataForm?.NombreAlumno || alumno?.NombreCompleto?.trim() || "",
            CURP: initDataForm?.CURP || "", // Se consulta de Información Extra
            NivelEducativo: initDataForm?.NivelEducativo || (alumno ? _DICC_ESCOLARIDAD.get(alumno.IdEscolaridad)?.NivelSAT || "" : ""),
            AutRVOE: initDataForm?.AutRVOE || (alumno ? _DICC_ESCOLARIDAD.get(alumno.IdEscolaridad)?.AutRVOE || "" : ""),
            RFCPago: initDataForm?.RFCPago || "",
        }
        let reseterDataBeforeState: IPagoInfoFacturarConceptoComplemento = null

        const formBase = new FormGenerator<IComplementoIEDU>()
            ._Crear({
                OnLoad: (container) => {
                    if (!reseterDataFormBase.NivelEducativo?.trim() || !reseterDataFormBase.AutRVOE?.trim()) {
                        container.append("span").text("Información faltante").style("color", "var(--color_app_red1)")
                    }
                },
                schema: [
                    {
                        model: "NombreAlumno",
                        type: "input",
                        labelText: _L("panelfinanzasedocuenta_factura.compl_nombrealumno"),
                        inputAttr: { required: true, disabled: true, removeBorder: true }
                    },
                    {
                        model: "CURP",
                        type: "input",
                        labelText: _L("panelfinanzasedocuenta_factura.compl_curp"),
                        onGetFixedValue: (value: string) => (value || "").toUpperCase(),
                        onValidate: (value) => UIUtilGeneral._ValidarCURP(value) || _L("general.curp_invalid"),
                        inputAttr: {
                            required: true, minlength: 18, maxlength: 19,
                            disabled: true, removeBorder: true,
                            onload: (input) => input.style("text-transform", "uppercase") // UIUtilMask._ApplyUpperCaseMask(input, false, true, false)
                        }
                    },
                    {
                        model: "NivelEducativo",
                        type: "input",
                        labelText: _L("panelfinanzasedocuenta_factura.compl_nivel"),
                        inputAttr: { required: true, disabled: true, removeBorder: true }
                    },
                    {
                        model: "AutRVOE",
                        type: "input",
                        labelText: _L("panelfinanzasedocuenta_factura.compl_autorizacion_rvoe"),
                        textInfo: _L("panelfinanzasedocuenta_factura.compl_autorizacion_rvoe_info"),
                        inputAttr: { required: true, disabled: true, removeBorder: true }
                    },
                    {
                        model: "RFCPago",
                        type: "input",
                        labelText: _L("panelfinanzasedocuenta_factura.compl_rfcpago"),
                        textInfo: _L("panelfinanzasedocuenta_factura.compl_rfcpago_info"),
                        onGetFixedValue: (value: string) => (value || "").toUpperCase(),
                        onValidate: (value) => UIUtilGeneral._ValidarRFC(value) || _L("general.rfc_invalid"),
                        inputAttr: {
                            minlength: 11, maxlength: 13,
                            onload: (input) => input.style("text-transform", "uppercase")
                        }
                    }
                ]
            })

        const formFinal: FormComplemento = formBase

        formBase._AsignaData((initDataForm || reseterDataFormBase) as IComplementoIEDU)

        formFinal.__SetReseterData = (reseterData) => {
            reseterDataBeforeState = reseterData
        }
        formFinal.__ResetForm = () => {
            formFinal._AsignaData(reseterDataBeforeState || reseterDataFormBase as any)
        }
        formFinal.__GetDataForm = () => {
            if (!formFinal._GetIsValidForm()) {
                NotificacionV2._Mostrar(_L("general.notif_fail"), "ADVERTENCIA")
                throw new Error("CFDI Complemento inválido")
            }
            return formBase._Data
        }
        // let firstShow = true
        formFinal.__FocusForm = () => {
            // if (firstShow) {
            //     firstShow = false
            //     if (!reseterDataFormBase.CURP) {
            //         LoadCurpToForm(idAlumno, formFinal).then(curp => { // FIXME REMOVER consulta innesesaria, CURP se invocará al inicio del proceso
            //             reseterDataFormBase.CURP = curp
            //         })
            //     }
            // }
        }

        return formFinal
    }

    // async function LoadCurpToForm(idAlumno: number, form: FormComplemento): Promise<string | null> {
    //     const { IdKinder } = (_DICC_ALUMNO.get(idAlumno) || {})
    //     if (!IdKinder) return null

    //     const control = form._GetModelControl("CURP")
    //     const progressBar = control.controlWrapper.append<HTMLProgressElement>("wc-progress").node()

    //     progressBar._Visible = true
    //     progressBar._Position = "bottom"

    //     await MainPage._ReloadServiceAndAwait(Entidad.CTipoRequest.EscuelaAlumnoInfoExtra, IdKinder)

    //     const fnFocusInput = () => (form._GetModelControl("CURP").selection.node() as HTMLInputElement).focus();

    //     return _SvAlumnoObtenerCurp(idAlumno, IdKinder)
    //         .then(res => {
    //             if (res.Resultado == 1) {
    //                 form._SetModelValue("CURP", res.CURP)
    //                 return res.CURP
    //             } else if (res.Resultado === -3 || res.Resultado === -1) {
    //                 NotificacionV2._Mostrar(_L("panelfinanzasedocuenta_factura.compl_fail_getcurp_404_alumno"), "MESSAGE");
    //             } else if (res.Resultado == -2) {
    //                 NotificacionV2._Mostrar(_L("panelfinanzasedocuenta_factura.compl_fail_getcurp"), "ADVERTENCIA");
    //             }
    //             fnFocusInput();
    //             return null
    //         })
    //         .finally(() => {
    //             progressBar.remove();
    //         })
    // }
}